import {createListResponseSchema} from 'src/feature/bite/domain'
import z from 'zod'

export const ActivitySchema = z.object({
  id: z.string().nullable(),
  type: z.any().nullable(),
  packageName: z.string().nullable(),
  packageItem: z.string().nullable(),
  storeName: z.string().nullable(),
  credit: z.number().nullable(),
  createdOn: z.string().nullable(),
  member: z.object({
    id: z.string().nullable(),
    name: z.string().nullable(),
    surname: z.string().nullable(),
  }),
})

export const ActivityListSchemaResponse = createListResponseSchema(ActivitySchema.array())
export type ActivityItemList = z.infer<typeof ActivityListSchemaResponse.shape.response>

const filterListSchema = z.array(
  z.object({
    operator: z.number(),
    key: z.string(),
    value: z.array(z.string()),
    logicalOp: z.number().optional(),
    childFilters: z.array(z.object({})).optional(),
  })
)

const orderListSchema = z.array(
  z.object({
    type: z.number(),
    key: z.string(),
  })
)

const pagingSchema = z.object({
  currentPageNumber: z.number(),
  pageSize: z.number(),
})

const searchSchema = z.object({
  value: z.string(),
  keyList: z.array(z.string()),
})

export const activityListFilterSchema = z.object({
  filterList: filterListSchema,
  orderList: orderListSchema,
  paging: pagingSchema,
  search: searchSchema,
})

export type ActivityListFilter = z.infer<typeof activityListFilterSchema>
